import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from 'lodash'

const _formData = {
  time: '',
}

const AddTimesModal = (props) => {
  const { handleClose, updateTimeSlots, hoursArray } = props
  const innerRef = useRef()
  const [formData, setFormData] = useState({ ..._formData })
  const [validated, setValidated] = useState(false)
  const { t } = useTranslation()

  //autofocus
  useEffect(() => innerRef.current && innerRef.current.focus(), [])

  //cleanup
  useEffect(() => {
    return () => clearData()
  }, [])

  const clearData = () => {
    setFormData({ ..._formData })
    setValidated(false)
  }

  const handleTimeInput = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 4)
    let formatted = raw
    if (raw.length >= 3) {
      formatted = raw.slice(0, 2) + ':' + raw.slice(2)
    }
    const isValid =
      raw.length === 4 &&
      parseInt(raw.slice(0, 2)) <= 23 &&
      parseInt(raw.slice(2)) <= 59
    setFormData({ time: formatted })
    setValidated(isValid)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (validated) {
      const hour = parseInt(formData.time.substring(0, 2))
      const minute = parseInt(formData.time.substring(3, 5))
      const newArray = cloneDeep(hoursArray)
      newArray[hour].push({ hour, minute })
      updateTimeSlots(newArray)
      handleClose()
    }
  }

  return (
    <>
      <Modal
        style={{ textAlign: 'center' }}
        centered
        show={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('appointment:addTime')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id='my-form' onSubmit={handleSubmit}>
            <Form.Group className='mb-3'>
              <Form.Label>{t('start')}</Form.Label>
              <Form.Control
                ref={innerRef}
                value={formData.time}
                type='text'
                placeholder='HH:MM'
                onChange={handleTimeInput}
                name='time'
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            form='my-form'
            variant='primary'
            disabled={!validated}
            type='submit'
          >
            {t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddTimesModal
